const PUBLISH_POSTING = 'avisos/publish/PUBLISH_POSTING';
const PUBLISH_POSTING_COMPLETED = 'avisos/publish/PUBLISH_POSTING_COMPLETED';
const PUBLISH_POSTING_FAILED = 'avisos/publish/PUBLISH_POSTING_FAILED';
const RESET_PUBLISH_POSTING = 'avisos/publish/RESET_PUBLISH_POSTING';

export { PUBLISH_POSTING, PUBLISH_POSTING_COMPLETED, PUBLISH_POSTING_FAILED, RESET_PUBLISH_POSTING };
